import { Controller } from '@hotwired/stimulus'
import ApexCharts from 'apexcharts'

export default class extends Controller {
  static values = {
    data: Array,
    name: String,
    categories: Array,
    colors: { type: Array, default: [] },
    textColors: { type: Array, default: [] },
    showTotals: { type: Boolean, default: false },
  }

  connect() {
    this.initializeChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  initializeChart() {
    if (this.chart) {
      this.chart.destroy()
    }

    const colors = this.colorsValue.length > 0 ? this.colorsValue : ['#EAB308']
    const textColors = this.textColorsValue.length > 0 ? this.textColorsValue : ['#111827']

    const options = {
      colors,
      chart: {
        type: 'bar',
        toolbar: { show: false },
        height: '100%',
        parentHeightOffset: 0,
        stacked: true,
        fontFamily: 'Inter, system-ui, sans-serif',
        animations: { enabled: false },
      },
      title: { text: undefined },
      series: this.dataValue,
      xaxis: {
        categories: this.categoriesValue,
        labels: {
          style: { fontSize: '12px', fontWeight: '500', colors: '#6B7280' },
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      yaxis: { show: false },
      grid: { show: false, padding: { left: 4, right: 4, top: 40 } },
      dataLabels: {
        enabled: true,
        style: { fontSize: '13px', fontWeight: '500', colors: textColors },
        formatter: (val) => (val > 0 ? val : ''),
      },
      tooltip: {
        enabled: true,
        shared: true,
        intersect: false,
        y: { formatter: (value, { seriesIndex, w }) => `${w.config.series[seriesIndex].name}: ${value}` },
      },
      plotOptions: {
        bar: {
          columnWidth: '68%',
          borderRadius: 4,
          borderRadiusApplication: 'end',
          borderRadiusWhenStacked: 'last',
          dataLabels: {
            total: {
              enabled: this.showTotalsValue,
              offsetY: -6,
              style: { fontSize: '15px', fontWeight: '700', color: '#111827' },
            },
          },
        },
      },
      legend: { show: false },
      states: { hover: { filter: { type: 'none' } } },
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }
}
